import 'organisms/DrawerContent/Payment/Payment.scss';

import { useState } from 'react';
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';

import { editLocation, loadProvider } from 'actions/provider';
import Button from 'atoms/button';
import Input from 'atoms/input';

export default function TipDefaultValues({
  isOpen,
  onRequestClose,
  defaultTips,
  onChangeDefaultTip,
}) {
  const dispatch = useDispatch();
  const { uuid } = useSelector((state) => state.provider);
  const [defaultValues, updateDefaultValues] = useState(defaultTips);

  const onChange = (tipValue, tipIndex) => {
    const newValues = defaultValues.map((tip, i) => {
      if (tipIndex === i) {
        return { value: `${tipValue}%`, id: +tipValue };
      } else return tip;
    });
    updateDefaultValues(newValues);
  };

  const onUpdate = async () => {
    const locationUpdated = await dispatch(
      editLocation({
        tips: defaultValues.map(({ id, value }) => ({
          description: value,
          percent: id,
        })),
      })
    );

    if (locationUpdated.success) {
      // We clear selected default tip, otherwise already selected value
      // might not match new value
      onChangeDefaultTip({});
      dispatch(loadProvider(uuid));
      onRequestClose(false);
    }
  };

  return (
    <ReactModal
      ariaHideApp={false}
      className="default-tips-modal"
      isOpen={isOpen}
      onRequestClose={() => onRequestClose(false)}
    >
      <h2 className="text-center f26">Tips default</h2>
      <p className="text-center f15">Customize your default tip values</p>
      <div className="flex-row mt-20 mb-30 justify-between default-tips-modal-container margin-center">
        {defaultValues.map((tip, i) => (
          <Input
            className="custom-tip-modal-input"
            value={tip.id}
            textAlignment="center"
            isPercentage
            key={defaultTips[i].id}
            onChange={(e) => onChange(e, i)}
            variant="white"
            size="small"
          />
        ))}
      </div>
      <div className="flex-row w-100 justify-center">
        <Button
          size="medium"
          text="Update"
          className="mr-15"
          onClick={onUpdate}
        />
        <Button
          size="medium"
          variant="reverse"
          onClick={() => onRequestClose(false)}
          text="Cancel"
        />
      </div>
    </ReactModal>
  );
}
